import { Button, Card } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { dispatchScheduleCreateModalOpenEvent, MiniSchedule } from "@/components";

const Schedule: React.FC = () => {
  const handleCreateClick = () => {
    dispatchScheduleCreateModalOpenEvent();
  };

  return (
    <Card
      title="日程"
      styles={{body: {padding: 0}, header: {border: 'none'}}}
      extra={(
        <Button
          shape="round"
          block
          icon={(<PlusOutlined/ >)}
          onClick={handleCreateClick}
          data-report="click"
          data-report-name="clickCreateScheduleButton"
          data-report-title="点击创建日程按钮"
          data-report-position="首页左侧日程"
        >
          新建
        </Button>
      )}
    >
      <MiniSchedule />
    </Card>
  );
};

export default Schedule;
